import { Component, OnDestroy, OnInit, AfterViewInit } from '@angular/core';
import { MENU_ITEMS, MENU_MANAGE_CARBO_ADMIN, MENU_MANAGE_OPERATOR_ADMIN, MENU_MANAGE_SERVICE_ADMIN } from './pages-menu';
import { UserAuthService, UserRolesService } from '../shared/services';
import { cloneDeep } from 'lodash';
import { Subscription, timer } from 'rxjs';
import { TreatmentService } from '../shared/services/treatment.service';
import { flatMap } from 'rxjs/operators';
import { Helper } from '../shared/helpers/helper';
import { ThemesSettingsService } from '../shared/services/themes-settings.service';
import { ENUM_THEMES } from '../shared/helpers/app.constants';

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss']
})
export class PagesComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];
  menu = [];
  isLoadingPage = false;

  isFieldEngineer: boolean = false;
  isDarkTheme: boolean;

  constructor(
    private userAuthService: UserAuthService,
    private userRolesService: UserRolesService,
    private themesSettingsService: ThemesSettingsService
  ) { }

  ngOnInit() {
    const localData = this.themesSettingsService.getLocalStorage();
    if (localData && localData.themes === ENUM_THEMES.Dark) {
      this.isDarkTheme = true;
      if (document.body.classList.value.toString().indexOf('frac-dark-theme') === -1) document.body.classList.add('frac-dark-theme');
    } else {
      document.body.classList.remove('frac-dark-theme');
    }
    const userInfo = this.userAuthService.getUserInfo();
    const userRole = this.userRolesService.toUserRole(userInfo);
    if (userRole.toLowerCase() === 'field engineer') {
      this.isFieldEngineer = true;
    }
    if (userInfo) {
      this.menu = this.initMenu(userInfo.companyType, userRole);
    }
  }

  ngOnDestroy(): void {
    Helper.unsubscribe(this.subscriptions);
  }


  initMenu(typeCompany: string, role: string) {
    let listMenu = cloneDeep(MENU_ITEMS);
    const isAdmin = this.userRolesService.isCarboAdmin(role) || this.userRolesService.isClientAdmin(role);
    if (!isAdmin && (this.userRolesService.isDataEngineer(role) || this.userRolesService.isAnalyst(role))) {
      if (typeCompany === 'Operator') {
        listMenu = listMenu.filter((item) => (item.title !== 'Manage' && item.title !== 'Inventory' && item.title !== 'Equip Monitoring'));
      } else {
        listMenu = listMenu.filter((item) => item.title !== 'Manage');
      }
    } else if (!isAdmin && role.toLowerCase() === 'field engineer') {
      if (typeCompany === 'Operator') {
        listMenu = listMenu.filter(
          (item) => (item.title !== 'Manage' && item.title !== 'Wells' && item.title !== 'Channel Mapping' && item.title !== 'Inventory' && item.title !== 'Equip Monitoring')
        );
      } else {
        listMenu = listMenu.filter((item) => (item.title !== 'Manage' && item.title !== 'Wells' && item.title !== 'Channel Mapping'));
      }
    } else if (isAdmin && role.toLowerCase() === 'admin' && typeCompany === 'Operator') {
      listMenu = listMenu.filter((item) => item.title !== 'Inventory' && item.title !== 'Equip Monitoring');
      listMenu.forEach((item) => {if (item.title === 'Manage') {
       item.children =  [...MENU_MANAGE_OPERATOR_ADMIN];
      }});
    } else if (isAdmin && role.toLowerCase() === 'admin' && typeCompany === 'Service') {
      listMenu.forEach((item) => {if (item.title === 'Manage') {
        item.children =  [...MENU_MANAGE_SERVICE_ADMIN];
      }});
    } else if (isAdmin && role.toLowerCase() === 'carbo admin') {
      listMenu.forEach((item) => {if (item.title === 'Manage') {
        item.children =  [...MENU_MANAGE_CARBO_ADMIN];
      }});
    }
    return listMenu;
  }

}
